/**
 * One product-loading skeleton shared by homepage, listings, and campaigns.
 * Server-rendered placeholders use the same class structure via the matching
 * product_card_skeleton.html include.
 */
(function(global) {
	function card(variant) {
		const listClass = variant === "list" ? " arac-product-skeleton--list" : "";
		return `
			<div class="arac-product-skeleton${listClass}" aria-hidden="true">
				<div class="arac-product-skeleton__media"></div>
				<div class="arac-product-skeleton__body">
					<span class="arac-product-skeleton__line arac-product-skeleton__line--title"></span>
					<span class="arac-product-skeleton__line arac-product-skeleton__line--meta"></span>
					<div class="arac-product-skeleton__footer">
						<span class="arac-product-skeleton__line arac-product-skeleton__line--price"></span>
						<span class="arac-product-skeleton__button"></span>
					</div>
				</div>
			</div>
		`;
	}

	function cards(count, variant) {
		const requested = Number.parseInt(count, 10);
		const safeCount = Number.isFinite(requested) ? Math.max(0, Math.min(requested, 24)) : 0;
		return Array.from({ length: safeCount }, function() {
			return card(variant);
		}).join("");
	}

	global.aracProductSkeleton = Object.freeze({ card, cards });
})(typeof window !== "undefined" ? window : globalThis);
